import { render, staticRenderFns } from "./CreateReceivedInvoice.vue?vue&type=template&id=1688e1b7&"
import script from "./CreateReceivedInvoice.vue?vue&type=script&lang=js&"
export * from "./CreateReceivedInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
